module.exports = __webpack_public_path__ + "static/media/Societe-Execution-Immobilier-Vaud.c70299cf.jpg";